import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AbstractControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { tabs } from 'src/app/dummy/tabs';
import { PrintService } from 'src/app/services/print.service';
import { Environment } from 'src/app/stores/environment.store';
import { Report } from 'src/app/stores/report.store';
import { MappingService } from 'src/app/services/mapping.service';
import { ConvertService } from 'src/app/services/convert.service';
import { SCHOOL } from 'src/app/dummy/config';

@Component({
  selector: 'app-installment-listings',
  templateUrl: './installment-listings.component.html',
  styleUrls: ['./installment-listings.component.scss']
})
export class InstallmentListingsComponent implements OnInit {
  tabs = tabs.reportFilterBy;
  form: FormGroup;
  fromDate: AbstractControl;
  toDate: AbstractControl;
  school=SCHOOL

  type: string;
  constructor(
    private fb: FormBuilder,
    private ps: PrintService,
    public env: Environment,
    private route: ActivatedRoute,
    public store: Report
  ) { }

  print() {
    this.ps.print("#print", "a4");
  }

  ngOnInit() {
    this.buildForm();
    this.route.params.forEach(param => {
      this.type = param["id"];
      const fromDate = MappingService.fromDateFilter(this.type);
      const toDate = MappingService.toDateFilter(this.type);
      this.form.patchValue({
        fromDate: fromDate,
        toDate: toDate
      });
      this.getList(fromDate, toDate);
    });
  }

  getList(fromDate, toDate) {
    this.env.getUser(user => {
      if (user)
        this.store.fetchInstallmentListing(ConvertService.toDateKey(fromDate), ConvertService.toDateKey(toDate), user.key);
    })
  }

  buildForm(): void {
    this.form = this.fb.group({
      fromDate: [null, Validators.required],
      toDate: [null, Validators.required],
    });

    this.fromDate = this.form.controls["fromDate"];
    this.toDate = this.form.controls["toDate"];
  }

  _onPress(f: any) {
    if (this.form.valid) {
      const { fromDate, toDate } = f;
      this.getList(fromDate, toDate);
    }
  }

}
